<button mat-fab type="button" [extended]="showLabel()" [attr.aria-label]="label()" (click)="doScrollTop()">
  <ui-icon matButtonIcon faName="arrow-up" faStyle="light" aria-hidden="true"></ui-icon>

  @if (showLabel()) {
    <span class="label">{{ label() }}</span>
  }
</button>
